import { ReactNode } from 'react'
import { IconPosition } from '../../../ct-design/@types'

export enum ChipShape {
    ROUND = 'ROUND',
    SQUARE = 'SQUARE'
}

export interface ChipProps {
    label: string
    showIcon?: boolean
    iconPosition?: `${IconPosition}`
    Icon?: ReactNode
    showCounter?: boolean
    count?: number
    isDismissible?: boolean
    isSelected?: boolean
    isDisabled?: boolean
    onClick: () => void
    onDismiss?: () => void
    id?: string
    textPaddingLeft?: string
    textPaddingRight?: string
    dataTestId?: string
    showLabel?: boolean
    shape?: `${ChipShape}`
}
